// Классификация исхода запроса авторизации и решение, что делать.
//
// Корень бага (App.tsx бутстрап): «сервер недоступен» (503 от NPM HTML-страницей,
// сетевой сбой, не-JSON ответ) обрабатывался так же, как «токен невалиден» (401) —
// показывался логин, а на refresh-ветке ещё и СТИРАЛИСЬ токены. Под перемежающимся
// 503 (придавленный апстрим / RKN-троттл) это выбрасывало юзера и не пускало обратно.
//
// Контракт (П0, закрывает класс): креды чистим ТОЛЬКО при подтверждённом отказе
// авторизации; при любой серверной/сетевой беде — держим креды и уходим в retry.

/** Класс исхода одного запроса авторизации. */
export type AuthOutcome = 'ok' | 'unauthorized' | 'unavailable';

/**
 * Классифицировать исход запроса (/me, /refresh, /telegram/auth).
 * @param status HTTP-статус; `null` если fetch или resp.json() БРОСИЛИ (сеть/не-JSON).
 * @param bodyOk значение `body.ok` для успешного 2xx (если тело распарсилось).
 */
export function classifyAuthOutcome(input: { status: number | null; bodyOk?: boolean }): AuthOutcome {
  const { status, bodyOk } = input;

  // Сеть упала или тело — не JSON (типичный 503-HTML от прокси): сервер недоступен.
  if (status === null) return 'unavailable';

  // Сервер здоров и однозначно отказал в доступе — единственный повод чистить креды.
  if (status === 401 || status === 403 || status === 404) return 'unauthorized';

  // Серверная беда → недоступен, креды НЕ трогаем.
  if (status >= 500) return 'unavailable';

  // Успех: доверяем только 2xx с body.ok === true.
  if (status >= 200 && status < 300) {
    return bodyOk === true ? 'ok' : 'unauthorized';
  }

  // Прочее (400, 429, иные 4xx) — не уверены, что креды протухли → бережём, retry.
  return 'unavailable';
}
